import config from "src/common/config"

type ApiPath = "graphql"

const PATHS = {
  graphql: "/graphql",
}

const ajaxPath = {
  get(key: ApiPath): string {
    return `${config.get("APP_WWW_URL")}${PATHS[key]}`
  },
}

export default ajaxPath
